import { useState } from 'react'
import { ItensPerUserLogged } from '../../../../../services/login/permissaoUsuarioLoado'
import { removerAcentos } from '../../../../../utils'
import { Inline } from '../../../../../Components/CustomUi/inline'
import Input from '../../../../../Components/CustomUi/input'
import ButtonCustom from '../../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { HeaderTable } from '../../../../../Components/CustomUi/table/headerTable'
import { BodyTable } from '../../../../../Components/CustomUi/table/bodyTable'
import { Render } from '../../../../../Components/CustomUi/render'
import { RowTable } from '../../../../../Components/CustomUi/table/rowTable'
import { RowItem } from '../../../../../Components/CustomUi/table/rowItem'
import { faEye } from '@fortawesome/free-solid-svg-icons'
import { Empty } from 'antd'
import Carregando from '../../../../../Components/CustomUi/loading'
import { ItensTesteBandeja } from '../../../../../services/relatorioTesteBandeja/GET'
import dayjs from 'dayjs'
import { BodyDrawer } from '../../styles'
import { TitleH1 } from '../../../../../Components/CustomUi/titleH1'


interface Props {
  loading: boolean
  listar_teste_medicao: ItensTesteBandeja[]
  abrirGaveta: Function
  desativar: boolean
}

export const TabelaMedicaoBandeja: React.FC<Props> = ({
  loading,
  listar_teste_medicao,
  abrirGaveta,
  desativar
}) => {
  const [buscarTabela, setBuscarTabela] = useState('')
  function buscarPatrimonios(buscar_nome: string) {
    const palavraSemAcentos = removerAcentos(buscar_nome)
    return function (item) {
      const nomeSemAcentos = removerAcentos(String(item?.nome))
      return nomeSemAcentos.toLowerCase().includes(palavraSemAcentos.toLowerCase()) || !buscar_nome
    }
  }

  return (
    <BodyDrawer>
      <TitleH1>Medições</TitleH1>
      <Inline alignItems='center'>
        <Input placeholder='Buscar laboratórios' value={buscarTabela} onChange={setBuscarTabela} />
      </Inline>
      <HeaderTable
        itens={[
          { valor: 'N° Medição', width: '150px' },
          { valor: 'Data', width: 'calc(100% - 265px)' },
          { valor: 'Ações', width: '110px' },
        ]}
      />

      <BodyTable
        style={{
          height: (listar_teste_medicao ?? []).length < 8 && 'auto',
          position: 'relative',
          overflowX: 'hidden',
          overflowY: 'scroll',
          marginTop: -10,
        }}
      >
        <Render condition={!loading}>
          {(listar_teste_medicao ?? [])
            .filter(buscarPatrimonios(buscarTabela))
            .map(({ cod, data }, index) => {
         
              return (
                <RowTable key={cod} onDoubleClick={() => {}}>
                  <RowItem fontSize={13} width={'150px'}>
                    {index + 1}
                  </RowItem>

                  <RowItem fontSize={13} width={'calc(100% - 260px)'}>
                     {dayjs(data).format('DD/MM/YYYY - HH:mm:ss')}
                  </RowItem>

                  <RowItem width={'110px'} gap={10}>
                   
                    <ButtonCustom
                      icon={<FontAwesomeIcon icon={faEye} />}
                      onClick={() => abrirGaveta(cod)}
                    >
                      Ver
                    </ButtonCustom>
                  </RowItem>
                </RowTable>
              )
            })}
        </Render>

        <Render condition={listar_teste_medicao?.length === 0 && !loading}>
          {buscarTabela === '' ? (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={<> Nenhum registro disponível!</>}
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <>
                  {' '}
                  <b>'{buscarTabela}'</b> não encontrado!
                </>
              }
            />
          )}
        </Render>

        <Render condition={loading}>
          <Carregando
            animation
            legenda='Carregando medições...'
            justifyContent='center'
            height={500}
            size='default'
          />
        </Render>
      </BodyTable>
    </BodyDrawer>
  )
}
